import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/constants";
import { LogOut, Menu, X } from "lucide-react";

const links = [
  { to: "/dashboard", label: "Dashboard" },
  { to: "/research/stocks", label: "Stocks" },
  { to: "/research/etfs", label: "Funds" },
  { to: "/compare", label: "Compare" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/chat", label: "AI Chat" },
  { to: "/academy", label: "Academy" },
];

export function Nav() {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const doLogout = async () => { await logout(); nav("/login"); };

  return (
    <header className="sticky top-0 z-40 border-b border-stone-200 bg-[#FBFBF9]/85 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <Link to="/dashboard" data-testid="nav-logo" className="flex items-center gap-2">
          <img src={LOGO_URL} alt="Tolulope Bello — Wealth Builder Hub" className="h-11 w-auto object-contain" />
        </Link>

        <nav className="hidden items-center gap-1 lg:flex">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
                loc.pathname === l.to ? "bg-stone-100 text-stone-900" : "text-stone-500 hover:bg-stone-50 hover:text-stone-900"
              }`}>{l.label}</Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <span className="hidden text-sm text-stone-500 sm:inline">{user?.name || user?.email}</span>
          <button onClick={doLogout} data-testid="logout-btn"
            className="hidden items-center gap-1.5 rounded-lg border border-stone-200 bg-white px-3 py-2 text-sm font-medium text-stone-700 transition-colors hover:bg-stone-50 sm:flex">
            <LogOut size={15} strokeWidth={1.5} /> Sign out
          </button>
          <button onClick={() => setOpen((v) => !v)} data-testid="mobile-menu-btn"
            className="flex h-10 w-10 items-center justify-center rounded-lg border border-stone-200 bg-white text-stone-700 lg:hidden">
            {open ? <X size={18} strokeWidth={1.5} /> : <Menu size={18} strokeWidth={1.5} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-stone-200 bg-[#FBFBF9] px-6 py-3 lg:hidden" data-testid="mobile-menu">
          <nav className="flex flex-col gap-1">
            {links.map((l) => (
              <Link key={l.to} to={l.to} onClick={() => setOpen(false)}
                data-testid={`mnav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className={`rounded-lg px-3 py-2.5 text-sm font-medium transition-colors ${
                  loc.pathname === l.to ? "bg-stone-100 text-stone-900" : "text-stone-600 hover:bg-stone-50"
                }`}>{l.label}</Link>
            ))}
            <button onClick={doLogout} data-testid="mobile-logout-btn"
              className="mt-1 flex items-center gap-1.5 rounded-lg px-3 py-2.5 text-left text-sm font-medium text-stone-600 hover:bg-stone-50">
              <LogOut size={15} strokeWidth={1.5} /> Sign out
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}
